













































































/** @format */

import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { selectCommunty, selectBuild, selectRoom } from '@/api/fixed-car-management';

@Component({
  components: {}
})
export default class RoomNumber extends Vue {
  @Prop({ type: Boolean }) showRoom!: boolean;
  @Prop({ type: String }) parkId!: string;
  @Prop({ type: Object }) form: {};
  @Prop({ type: String }) transfer: string;

  communtyList: any[] = [];
  buildList: any[] = [];
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  selectedRowKeys: string[] = [];
  selectedRows: string[] = [];
  filterParam: Record<string, any> = {
    commId: '',
    buildId: '',
    searchParam: ''
  };

  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '房间号',
        dataIndex: 'roomName',
        width: 220,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '姓名',
        dataIndex: 'ownerName',
        width: 130,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '电话',
        dataIndex: 'mobile',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '管理区',
        dataIndex: 'commName',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '楼栋',
        dataIndex: 'buildName',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse' }
      }
    ];
  }
  // 获取管理区
  async getSelectCommunty() {
    try {
      const { status, msg, code, data } = await selectCommunty({
        parkId: this.parkId
      });
      if (status === '9999') {
        this.communtyList = data.map(item => {
          return {
            label: item.commName,
            value: item.commId
          };
        });
        if (this.communtyList.length > 0) {
          this.filterParam.commId = this.filterParam.commId ? this.filterParam.commId : this.communtyList[0].value;
          this.getSelectBuild();
        }
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  // 获取楼栋
  async getSelectBuild() {
    this.filterParam.buildId = '';
    try {
      const { status, msg, code, data } = await selectBuild({
        parkId: this.parkId,
        commId: this.filterParam.commId
      });
      if (status === '9999') {
        this.buildList = data.map(item => {
          return {
            label: item.buildName,
            value: item.buildId
          };
        });
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  // 列表数据
  async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { status, msg, code, data, total } = await selectRoom({
        parkId: this.parkId,
        commId: this.filterParam.commId,
        buildId: this.filterParam.buildId,
        searchParam: this.filterParam.searchParam,
        pageSize: this.pageSize,
        curPage: this.current
      });
      if (status === '9999') {
        this.tableData = data.list;
        this.total = Number(data.total);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  // 分页
  showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }

  onSelectChange(selectedRowKeys: string[], selectedRows: string[]) {
    console.log(selectedRowKeys, selectedRows);
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRows = selectedRows;
  }

  search() {
    this.current = 1;
    this.pageSize = 10;
    this.fetchTableData();
  }

  clear() {
    this.filterParam = {
      commId: '',
      buildId: '',
      searchParam: ''
    };
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.current = 1;
    this.pageSize = 10;
    this.fetchTableData();
  }

  onSubmit() {
    if (this.selectedRows.length === 0) {
      this.$message.error('请选择至少一条数据！');
      return;
    }
    // 只能选ownerId相同的数据
    const ownerIdArr: any[] = [];
    this.selectedRows.forEach(item => {
      ownerIdArr.push((item as any).ownerId);
    });
    if (Array.from(new Set(ownerIdArr)).length > 1) {
      this.$message.error('请选择同一个业主下的房间号！');
      return;
    }
    // 选择ownerId相同的数据下的所有roomId
    this.selectedRows.map(item => (item as any).ownerId === ownerIdArr[0]);
    console.log('selectedRows--', this.selectedRows);
    console.log('form--', this.form);
    (this.form as any).setFieldsValue({
      roomNum: (this.selectedRows[0] as any).roomName,
      userName: (this.selectedRows[0] as any).ownerName,
      phoneNum: (this.selectedRows[0] as any).mobile
    });
    this.onCancel();
  }

  onCancel() {
    this.$parent.showRoom = false;
    this.filterParam = {
      commId: '',
      buildId: '',
      searchParam: ''
    };
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.communtyList = [];
    this.buildList = [];
    this.tableData = [];
  }

  @Watch('showRoom')
  async onShowRoomChanged(value: boolean) {
    if (value) {
      await this.getSelectCommunty();
      await this.search();
    }
  }
}
